import React from 'react';
import { ChefHat } from 'lucide-react';
import Header from './Header';

const Hero = () => {
  const scrollToBooking = () => {
    const element = document.getElementById('booking');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden" style={{background: 'linear-gradient(to bottom right, hsl(0, 0%, 12%), hsl(0, 64%, 20%), hsl(0, 0%, 12%))'}}>
      <Header />
      
      {/* Decorative elements */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-20 left-10 w-96 h-96 bg-gold rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-burgundy rounded-full blur-3xl"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center py-32">
        <div className="mb-8 flex justify-center">
          <div className="inline-flex items-center justify-center w-24 h-24 bg-gold/20 rounded-full backdrop-blur-sm border-2 border-gold/40 shadow-xl">
            <ChefHat className="w-12 h-12 text-gold" strokeWidth={1.8} />
          </div>
        </div>

        <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-cream mb-6 leading-tight drop-shadow-lg">
          Du Sourire à la Fourchette
        </h1>
        
        <p className="text-2xl sm:text-3xl text-gold mb-4 font-semibold">
          Traiteur à Domicile
        </p>
        
        <p className="text-lg sm:text-xl text-cream mb-12 max-w-2xl mx-auto leading-relaxed">
          Des moments gourmands et conviviaux, préparés avec passion pour sublimer vos événements
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <button
            onClick={scrollToBooking}
            className="px-8 py-4 bg-gold text-charcoal font-bold rounded-lg hover:bg-gold/90 transform hover:scale-105 transition-all duration-200 shadow-xl hover:shadow-2xl"
          >
            Réserver Maintenant
          </button>
          <button
            onClick={() => {
              const element = document.getElementById('services');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="px-8 py-4 bg-transparent text-cream font-semibold rounded-lg border-2 border-cream/50 hover:border-gold hover:text-gold hover:bg-gold/10 transition-all duration-200"
          >
            Découvrir nos Services
          </button>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-cream/50 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-3 bg-cream/70 rounded-full"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;